import * as React from "react"

import { SubscriptionList } from "./client"

type Props = {
  initialSubscriptionLists: SubscriptionList[]
  onSave: (lists: SubscriptionList[]) => Promise<void>
  onUnsubscribeFromAll: () => void
}

const SubscriptionForm: React.FC<Props> = ({
  initialSubscriptionLists,
  onSave,
  onUnsubscribeFromAll,
}) => {
  const [lists, setLists] = React.useState(initialSubscriptionLists)
  const [saving, setSaving] = React.useState(false)
  const updateList = React.useCallback(
    (id: string, subscribed: boolean) => {
      setLists((lists) => {
        return lists.map((list) => {
          if (list.id === id) return { ...list, subscribed }
          return list
        })
      })
    },
    [setLists]
  )
  const onFormSubmitted = React.useCallback(
    (ev: React.FormEvent) => {
      ev.preventDefault()
      setSaving(true)
      onSave(lists).finally(() => setSaving(false))
    },
    [lists]
  )
  return (
    <form onSubmit={onFormSubmitted}>
      <fieldset style={{ border: "none", padding: "0" }}>
        <legend style={{ fontWeight: "bold" }}>
          Communication Preferences
        </legend>
        <a
          href="#skip_subscription-list"
          style={{ position: "absolute", height: 1, overflow: "hidden" }}
        >
          Skip subscription list
        </a>
        <ul style={{ padding: 0, maxHeight: "50vh", overflowY: "auto" }}>
          {lists.map((list) => (
            <li
              key={list.id}
              style={{ marginBottom: 6, listStyleType: "none" }}
            >
              <label
                style={{
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  marginTop: 0,
                }}
              >
                <input
                  type="checkbox"
                  checked={list.subscribed}
                  onChange={(ev) => updateList(list.id, ev.target.checked)}
                  name={list.id}
                />
                {list.name}
                {list.description && (
                  <p
                    style={{
                      margin: 0,
                      marginLeft: 20,
                      fontSize: "90%",
                      fontWeight: "normal",
                    }}
                  >
                    {list.description}
                  </p>
                )}
              </label>
            </li>
          ))}
        </ul>
      </fieldset>
      <div id="skip_subscription-list">
        <button
          type="submit"
          disabled={saving}
          style={{
            width: "100%",
            maxWidth: "100vw",
            border: "none",
            background: "#333333",
            color: "#ffffff",
            padding: 8,
            borderRadius: 3,
            cursor: "pointer",
          }}
        >
          Save communication preferences
        </button>
        <br />
        <button
          type="button"
          disabled={saving}
          style={{
            width: "100%",
            maxWidth: "100vw",
            border: "none",
            background: "#cdcdcd",
            color: "#000000",
            padding: 8,
            marginTop: 16,
            borderRadius: 3,
            cursor: "pointer",
          }}
          onClick={() => {
              setSaving(true)
              onUnsubscribeFromAll()
            }
          }
        >
          Unsubscribe from all emails
        </button>
      </div>
    </form>
  )
}

export default SubscriptionForm
